import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as S from './styled';
import { EVENTS as E } from '../../core/constants';
import { useSendEvents } from '../../core/hooks';
import { selectEnFlagVariant } from '../../core/store/locale';
import { flagUrl, getActiveLanguageItem, resolveEnFlagVariant } from '../../locales/languageConfig';
import { LanguageModal } from '../LanguageModal';

interface LanguagePickerProps {
  screenId: string;
}

export const LanguagePicker = ({ screenId }: LanguagePickerProps) => {
  const { i18n } = useTranslation();
  const sendEvents = useSendEvents({ screenId });
  const enFlag = resolveEnFlagVariant(useSelector(selectEnFlagVariant));
  const [isOpen, setIsOpen] = useState(false);
  const chipRef = useRef<HTMLButtonElement>(null);
  const { code, flagFile } = getActiveLanguageItem(i18n.language, enFlag);

  return (
    <>
      <S.FlagChip
        ref={chipRef}
        type="button"
        aria-haspopup="dialog"
        onClick={() => {
          sendEvents('header_language_picker__click', { [E.BC]: 'language_modal' });
          setIsOpen(true);
        }}
      >
        <S.FlagChipImg src={flagUrl(flagFile)} alt="" />
        <S.FlagCode>{code}</S.FlagCode>
      </S.FlagChip>
      {isOpen && (
        <LanguageModal
          screenId={screenId}
          onClose={() => {
            setIsOpen(false);
            chipRef.current?.focus();
          }}
        />
      )}
    </>
  );
};
